
import {Vue, Component} from 'vue-property-decorator';
import Pagination from "@/components/Pagination/index.vue";
import {
  detailQueryPiPackagingDetailHeadInfo,
  downloadPiUnmatched,
  pageQueryPiUnmatchedPackagingDetail
} from "@/api/customer-package";

@Component({
  name: 'NoPackageDetail',
  components: {Pagination}
})
export default class extends Vue {
  private searchParams = {
    numberKeyword: "",
  }

  private headerInfo = {
    piId: "",
    piCode: "",
    seller: "",
    customer: "",
    orderDate: "",
  };

  private tableData = []
  private modelColumnNames: string[] = []
  private page = {
    pageNumber: 1,
    pageSize: 20,
    total: 0,
  }
  private isFirstActivated = true;

  created() {
    this.initHeaderInfoFromRoute();
    this.getHeadInfo();
    this.getList();
  }

  activated() {
    if (this.isFirstActivated) {
      this.isFirstActivated = false;
      return;
    }
    this.initHeaderInfoFromRoute();
    this.getHeadInfo();
    this.getList();
  }

  private initHeaderInfoFromRoute() {
    const item = this.$route.query.item as string;
    if (!item) {
      return;
    }
    const json = decodeURIComponent(item);
    const data = JSON.parse(json);
    this.headerInfo.piId = data.piId;
  }

  private getModelNumber(row: any, modelName: string) {
    const map = row?.modelNumberMap;
    if (map && map[modelName] !== undefined && map[modelName] !== null) {
      return map[modelName];
    }
    // 没找到又去row.models里找了一遍
    const models = row?.models || [];
    const target = models.find((m: any) => m?.modelName === modelName);
    return target?.number || '';
  }

  private async getHeadInfo() {
    const res = await detailQueryPiPackagingDetailHeadInfo(this.headerInfo.piId) as any;
    this.headerInfo.piCode = res.code;
    this.headerInfo.seller = res.seller;
    this.headerInfo.customer = res.customerAbbr;
    this.headerInfo.orderDate = res.orderDate;
  }

  private async getList() {
    const params = {
      ...this.searchParams,
      pageNumber: this.page.pageNumber,
      pageSize: this.page.pageSize,
    }
    const res = await pageQueryPiUnmatchedPackagingDetail(this.headerInfo.piId, params) as any;
    this.page.total = Number(res.total);
    const list = (res.list || []).map((item: any) => ({
      ...item,
      modelNumberMap: Array.isArray(item?.models)
        ? item.models.reduce((acc: any, m: any) => {
          acc[m.modelName] = m.number;
          return acc;
        }, {})
        : {},
    }));
    this.tableData = list;
    const names: string[] = [];
    const set = new Set<string>();
    list.forEach((row: any) => {
      (row?.models || []).forEach((m: any) => {
        const name = m?.modelName;
        if (!name || set.has(name)) {
          return;
        }
        set.add(name);
        names.push(name);
      });
    });
    this.modelColumnNames = names;
  }

  private async downloadList() {
    await downloadPiUnmatched(this.headerInfo.piId);
  }
}
